module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/carousel_04@1x.a2b2626.png";